import VideoPauseOverlayIcon from '@atlaskit/icon/core/video-pause-overlay';
import * as React from 'react';

export function SvgPause() {
  return <VideoPauseOverlayIcon label="" testId="ads-refreshed-icon" />;
}
